export default (element: HTMLElement) => {
    element.scrollTo({ top: 0 });
};
